<template>
  <!-- 平台设置---对账开关 -->
  <div class="page box_column">
    <!-- 提示信息 -->
    <Headertip :tipContent="tipContent" />
    <!-- 表格信息 -->
    <el-table :data="tableData" style="width: 100%" header-row-class-name="table-header">
      <el-table-column
        v-for="(item, index) in tableData"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
      >
        <template slot-scope="scope" v-if="item.prop != 'status'">
          <i class="el-icon-time" v-if="false"></i>
          <span style="margin-left: 10px">{{ scope.row[item.prop] }}</span>
        </template>
        <template v-else slot-scope="scope">
          <el-switch class="switch-btn" v-model="scope.row[item.prop]" active-color="#4359B7" inactive-color="#BEBEBE">
          </el-switch>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { tableData } from '@set-up/static/data.js';
export default {
  name: 'switch',
  data() {
    return {
      tipContent:
        '开启对账功能后，即可在打开对账开关的第二天上午 10 点后（根据开通支付渠道不同，对账结果显示时间可能延后），查看到当天的对账结果；佰医支付平台只会对开启对账开关后的聚合支付交易，每日进行自动对账；未开启对账开关前的历史交易，不进行对账处理。',
      tableData,
    };
  },
  methods: {},
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.page {
  height: 100%;
}
.el-table {
  flex: 1;
  /deep/.el-switch__core {
    height: 24px;
    border-radius: 12px;
  }
  /deep/.cell {
    line-height: 25px;
  }
  /deep/.el-switch__core:after {
    width: 20px;
    height: 20px;
  }
  /deep/.el-switch.is-checked .el-switch__core::after {
    margin-left: -21px;
  }
}
/deep/.table-header .cell {
  color: #999999;
  font-weight: 400;
}
</style>
